<template>
  <generic-modal :title="$t('little jar')" ref="generic_modal">
    <form>
      <div class="field">
        <label class="label">{{ $t("name") }}</label>
        <div class="control">
          <input
            readonly
            type="text"
            class="input"
            :value="calculated_name"
            :placeholder="$t('name')"
          />
        </div>
      </div>
      <div class="columns" v-if="meta.settings">
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("component") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.settings.component"
                :placeholder="$t('component')"
              />
            </div>
          </div>
        </div>
        <div class="column">
          <div class="field">
            <label class="label">{{ $t("potency") }}</label>
            <div class="control">
              <input
                type="text"
                class="input"
                v-model="meta.settings.potency"
                :placeholder="$t('potency')"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <div class="control">
          <generic-uploader
            ref="generic_uploader"
            :idle_label="$t('drop little jar images')"
            endpoint_url="/little_jar/photo"
            @error="error_uploading"
            @success="success_uploading"
            :allow_multiple="true"
          />
        </div>
        <!-- <pre>{{ meta }}</pre> -->
      </div>
    </form>
    <div class="grid is-col-min-7">
      <div
        v-if="meta && meta.settings && meta.settings.images"
        class="cell"
        v-for="(photo, midx) in meta.settings.images"
        :key="midx"
      >
        <div class="card">
          <div class="card-image">
            <figure class="image is-128x128 m-auto py-3">
              <v-lazy-image
                :src="`${api_host}/drive/static/${photo.final_name}`"
              />
            </figure>
          </div>
          <div class="card-content">
            <div class="media">
              <div class="media-content">
                <p class="subtitle is-7 has-text-centered"></p>
              </div>
            </div>
          </div>
          <footer class="card-footer">
            <div
              class="button is-secondary card-footer-item"
              @click="meta.settings.images.splice(midx, 1)"
              :data-tooltip="$t('delete')"
            >
              <span class="icon">
                <i class="fa fa-trash"></i>
              </span>
              <!-- <span>{{ $t("delete") }}</span> -->
            </div>
          </footer>
        </div>
      </div>
    </div>
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
    <template v-slot:footer>
      <button
        class="button is-primary is-rounded"
        @click="save"
        :disabled="is_form_invalid"
      >
        <span class="icon">
          <i class="fa fa-save"></i>
        </span>
        <span>{{ $t("save") }}</span>
      </button>
      <button class="button is-rounded" @click="close_modal">
        <span class="icon">
          <i class="fa fa-close"></i>
        </span>
        <span>{{ $t("cancel") }}</span>
      </button>
    </template>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
  api_host,
} from "@/utils";
import GenericUploader from "@/components/generic_uploader/Index.vue";
import GenericModal from "@/components/generic_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "LittleJarModal",
  components: { GenericModal, GenericUploader, VLazyImage },
  props: {},
  data() {
    return {
      api_host,
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return (
        v.meta.settings &&
        (!v.meta.settings.component || !v.meta.settings.potency)
      );
    },
    calculated_name() {
      let v = this;
      if (v.meta && v.meta.settings) {
        let component_words = v.meta.settings.component
          ? v.meta.settings.component.split(" ")
          : [];
        let first_3_letter_of_words = component_words.map((word) => {
          return word.substring(0, 3);
        });
        let cmp = first_3_letter_of_words.join("");
        return `${cmp} ${v.meta.settings.potency || ""}`;
      } else return "";
    },
  },
  methods: {
    close_modal() {
      let v = this;
      v.set_initial_state();
      v.$refs.generic_modal.close_modal();
    },
    show_modal(little_jar_uuid) {
      let v = this;
      v.set_initial_state();
      if (little_jar_uuid) {
        get("/little_jar", { uuid: little_jar_uuid })
          .then((response) => {
            v.meta = response;
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;

      v.meta.name = v.calculated_name;
      if (v.meta.uuid) {
        post("/little_jar", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      } else {
        put("/little_jar", v.meta)
          .then(() => {
            v.$emit("success");
            v.$refs.generic_modal.close_modal();
          })
          .catch((error) => {
            v.error = generate_error_message_text(error);
          });
      }
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        name: "",
        settings: {},
      };
      v.error = "";
      v.$refs.generic_uploader.clear();
    },
    error_uploading(error) {
      let v = this;
      v.error = generate_error_message_text(error);
    },
    success_uploading(response) {
      let v = this;
      // v.$refs.generic_uploader.clear();
      let rspnse = JSON.parse(response.serverId);
      let data = {
        file_id: rspnse.file.file_id,
        final_name: rspnse.final_name,
      };
      if (v.meta.settings.images) {
        v.meta.settings.images.push(data);
      } else {
        v.meta.settings.images = [data];
      }
    },
  },
  mounted() {},
  watch: {},
};
</script>
<style></style>
